import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { debounce } from 'lodash'
import { formatPrice, constants, snowplow, getElementInViewport } from 'common/helpers'
import cx from 'classnames'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import ProductCardBase from 'components/product/ProductCardBase/ProductCardBase'

import messages from './messages'
import s from './Product.scss'


class Product extends Component {

  static propTypes = {
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    buttonTitle: PropTypes.object,
    isQuickViewVisible: PropTypes.bool,
    isButtonAlways: PropTypes.bool,
    isHoverEffect: PropTypes.bool,
    addTo: PropTypes.oneOf([ 'queue', 'cart', false ]),
    defaultSelectedQuickViewType: PropTypes.string,
    link: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
    ]),
    metadata: PropTypes.shape({
      placement: PropTypes.string,
    }),
    snowplowMetadata: PropTypes.object,
    dataTestId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    isBrandVisible: PropTypes.bool,
    isCategoryVisible: PropTypes.bool,
    isPriceVisible: PropTypes.bool,
    onBlockClick: PropTypes.func,
    onButtonClick: PropTypes.func,
    onQuickViewClick: PropTypes.func,
    isWholeBlockAsButton: PropTypes.bool,
    isRatingStarBlack: PropTypes.bool,
    data: PropTypes.object,
    lazyImage: PropTypes.bool,
    contentNodeInject: PropTypes.node,
  }

  static defaultProps = {
    isQuickViewVisible: false,
    isHoverEffect: true,
    isBrandVisible: true,
    isCategoryVisible: true,
    isPriceVisible: false,
    lazyImage: false,
  }

  componentDidMount() {
    const { handleProductInViewport } = this.props

    if (handleProductInViewport) {
      document.addEventListener('scroll', this.handleDocumentScroll)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleDocumentScroll)
  }

  handleDocumentScroll = debounce(() => {
    const { handleProductInViewport, data: { id, name } } = this.props

    const isElementInViewport = getElementInViewport(this.productEl)

    if (isElementInViewport) {
      handleProductInViewport({
        id,
        name,
      })
    }
  }, 300)

  setProductElementRef = (element) => {
    this.productEl = element
  }

  handleQuickViewClick = (event) => {
    const {
      data: { id, previewId, name, category, upchargePrice },
      metadata, defaultSelectedQuickViewType, onQuickViewClick,
    } = this.props

    event.preventDefault()
    event.stopPropagation()

    if (typeof onQuickViewClick === 'function') {
      onQuickViewClick()
    }

    if (upchargePrice) {
      metadata.premium = upchargePrice
    }

    // TODO SNOWPLOW: add properties
    snowplow.track(constants.snowplowEvents.quickViewClick, {
      // placement,
      productId: id,
      productName: name,
      productCategory: category,
    })

    actions.models.modals.open(constants.modals.ProductDetails, {
      productId: previewId || id,
      defaultSelectedQuickViewType,
    })
  }

  render() {
    const {
      containerClassName, className, link, dataTestId,
      data, data: { url, img, image, brand, category, name, price, typeGroup },
      isQuickViewVisible, onButtonClick, onBlockClick, isWholeBlockAsButton,
      isBrandVisible, isCategoryVisible, isPriceVisible,
      lazyImage, contentNodeInject, addTo, buttonTitle, isHoverEffect,
      metadata, onQuickViewClick, snowplowMetadata, defaultSelectedQuickViewType,
      isRatingStarBlack, isButtonAlways, isAddToButtonHidden, children,
    } = this.props

    const contentNode = (
      <Fragment>
        {
          contentNodeInject
        }
        <Box relative>
          {
            isQuickViewVisible && (
              <Fragment>
                <Text
                  className={s.quickViewButton}
                  message={messages.quickView}
                  dataTestId={constants.testIds.payment.quickViewButton}
                  size="12-16"
                  align="center"
                  color="white"
                  tag="button"
                  uppercase
                  onClick={this.handleQuickViewClick}
                />
              </Fragment>
            )
          }
          {
            isBrandVisible && (
              <Text message={brand} size="14-24" semibold uppercase />
            )
          }
          <Box mt="4">
            <Text message={name} size="14-24" />
          </Box>
          {
            isCategoryVisible && (
              <Box mt="4">
                <Text message={category} size="14-24" />
              </Box>
            )
          }
          {
            isPriceVisible && (
              <Box mt="4">
                <Text message={formatPrice(price, true)} size="14-24" bold />
              </Box>
            )
          }
        </Box>
      </Fragment>
    )

    return (
      <ProductCardBase
        className={cx(s.productBase, className)}
        containerClassName={containerClassName}
        _ref={this.setProductElementRef}
        data={data}
        link={link === false ? link : (link || url)}
        imgSrc={image || img} // TODO refactor to image
        content={contentNode}
        isWholeBlockAsButton={isWholeBlockAsButton}
        dataTestId={dataTestId}
        typeGroup={typeGroup}
        lazyImage={lazyImage}
        onBlockClick={onBlockClick}
        onButtonClick={onButtonClick}
        addTo={addTo}
        buttonTitle={buttonTitle}
        isHoverEffect={isHoverEffect}
        metadata={metadata}
        onQuickViewClick={onQuickViewClick}
        snowplowMetadata={snowplowMetadata}
        defaultSelectedQuickViewType={defaultSelectedQuickViewType}
        isRatingStarBlack={isRatingStarBlack}
        isButtonAlways={isButtonAlways}
        isAddToButtonHidden={isAddToButtonHidden}
      >
        {children}
      </ProductCardBase>
    )
  }
}


export default Product
